/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import * as Types from '../../../queryTyping';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetBankAccountsQueryVariables = Types.Exact<{
  includeHiddenInGroups: Types.Scalars['Boolean'];
  invalidateCache: Types.Scalars['Boolean'];
}>;


export type GetBankAccountsQuery = (
  { __typename?: 'Query' }
  & { userBankAccounts: (
    { __typename?: 'GetUserBankAccountsResult' }
    & Pick<Types.GetUserBankAccountsResult, 'isHiddenAccountsEnabled' | 'isAccountIconEnabled' | 'isGroupingEnabled' | 'isAccountGroupTotalsHidden' | 'isPlaidAccountsEnabled' | 'isOpeningAccountEnabled' | 'isLinkInternalAccountEnabled'>
    & { groups: Array<(
      { __typename?: 'BankAccountGroup' }
      & Pick<Types.BankAccountGroup, 'id' | 'name' | 'total'>
      & { accounts: Array<(
        { __typename?: 'BankAccountRef' }
        & Pick<Types.BankAccountRef, 'accountId'>
      )> }
    )>, accounts: Array<(
      { __typename?: 'BankAccountInfo' }
      & Pick<Types.BankAccountInfo, 'id' | 'accountNumber' | 'description' | 'type' | 'accessType' | 'name' | 'isClosed' | 'isVisible' | 'isTransactionsHistorySupported' | 'isTransferDestinationAllowed' | 'isTransferSourceAllowed' | 'isForCrossAccountTransferOnly' | 'isBillPayEligible' | 'productId' | 'maskedMemberNumber' | 'availableBalance' | 'ledgerBalance' | 'userFriendlyLedgerBalance'>
      & { ownerMembership: Types.Maybe<(
        { __typename?: 'BankAccountMembershipInfo' }
        & Pick<Types.BankAccountMembershipInfo, 'number' | 'displayName'>
      )>, accessMembership: Types.Maybe<(
        { __typename?: 'BankAccountMembershipInfo' }
        & Pick<Types.BankAccountMembershipInfo, 'number' | 'displayName'>
      )>, savingDetails: Types.Maybe<(
        { __typename?: 'BankAccountSavingDetails' }
        & Pick<Types.BankAccountSavingDetails, 'regDCount' | 'irsMaxContributionCty' | 'irsCurrentContributionCty' | 'savingType'>
      )>, loanDetails: Types.Maybe<(
        { __typename?: 'BankAccountLoanDetails' }
        & Pick<Types.BankAccountLoanDetails, 'loanType' | 'nextPaymentDate' | 'nextPaymentAmount' | 'minimumPaymentAmount' | 'overduePaymentAmount' | 'lastStatementDate' | 'lastStatementBalance' | 'payoffAmount' | 'paymentAmount' | 'isOverdueInPaymentAmount'>
      )>, investmentDetails: Types.Maybe<(
        { __typename?: 'BankAccountInvestmentDetails' }
        & Pick<Types.BankAccountInvestmentDetails, 'todayPercent' | 'todayAmount'>
      )> }
    )> }
  ) }
);


export const GetBankAccountsDocument = gql`
    query GetBankAccounts($includeHiddenInGroups: Boolean!, $invalidateCache: Boolean!) {
  userBankAccounts(
    includeHiddenInGroups: $includeHiddenInGroups
    invalidateCache: $invalidateCache
  ) {
    isHiddenAccountsEnabled
    isAccountIconEnabled
    isGroupingEnabled
    isAccountGroupTotalsHidden
    isPlaidAccountsEnabled
    isOpeningAccountEnabled
    isLinkInternalAccountEnabled
    groups {
      id
      name
      total
      accounts {
        accountId
      }
    }
    accounts {
      id
      accountNumber
      description
      type
      accessType
      name
      isClosed
      isVisible
      isTransactionsHistorySupported
      isTransferDestinationAllowed
      isTransferSourceAllowed
      isForCrossAccountTransferOnly
      isBillPayEligible
      productId
      maskedMemberNumber
      availableBalance
      ledgerBalance
      userFriendlyLedgerBalance
      ownerMembership {
        number
        displayName
      }
      accessMembership {
        number
        displayName
      }
      savingDetails {
        regDCount
        irsMaxContributionCty
        irsCurrentContributionCty
        savingType
      }
      loanDetails {
        loanType
        nextPaymentDate
        nextPaymentAmount
        minimumPaymentAmount
        overduePaymentAmount
        lastStatementDate
        lastStatementBalance
        payoffAmount
        paymentAmount
        isOverdueInPaymentAmount
      }
      investmentDetails {
        todayPercent
        todayAmount
      }
    }
  }
}
    `;

/**
 * __useGetBankAccountsQuery__
 *
 * To run a query within a React component, call `useGetBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankAccountsQuery({
 *   variables: {
 *      includeHiddenInGroups: // value for 'includeHiddenInGroups'
 *      invalidateCache: // value for 'invalidateCache'
 *   },
 * });
 */
export function useGetBankAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetBankAccountsQuery, GetBankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankAccountsQuery, GetBankAccountsQueryVariables>(GetBankAccountsDocument, options);
      }
export function useGetBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankAccountsQuery, GetBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankAccountsQuery, GetBankAccountsQueryVariables>(GetBankAccountsDocument, options);
        }
export type GetBankAccountsQueryHookResult = ReturnType<typeof useGetBankAccountsQuery>;
export type GetBankAccountsLazyQueryHookResult = ReturnType<typeof useGetBankAccountsLazyQuery>;
export type GetBankAccountsQueryResult = Apollo.QueryResult<GetBankAccountsQuery, GetBankAccountsQueryVariables>;